import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './services/guard/auth.guard';
import { PendingOrdersComponent } from './pages/pending-orders/pending-orders.component';
import { StockComponent } from './pages/stock/stock.component';
import { PricesComponent } from './pages/prices/prices.component';
import { ActivityComponent } from './pages/activity/activity.component';
import { BalanceComponent } from './pages/balance/balance.component';
import { VisitComponent } from './pages/visit/visit.component';
import { RemitosComponent } from './pages/remitos/remitos.component';
import { PlanillaPdfComponent } from './pages/planilla-pdf/planilla-pdf.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'balance',
    component: BalanceComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'pending',
    component: PendingOrdersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'stock',
    component: StockComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'prices',
    component: PricesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activity',
    component: ActivityComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'visit',
    component: VisitComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'remitos',
    component: RemitosComponent,
    canActivate: [AuthGuard]
  },
    {
    path: 'planilla',
    component: PlanillaPdfComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
